import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

const TwoPagePdfViewer = ({ url, page, onDocumentLoadSuccess, numPages }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  return (
    <div className="two-page-pdf-viewer">
      <Document
        file={{ url: url, headers: { 'Access-Control-Allow-Origin': '*' } }}
        onLoadSuccess={onDocumentLoadSuccess}
        pageLayout={'oneColumn'}
        className={'two-page-pdf-viewer__document'}
      >
        <Page
          pageNumber={page}
          renderAnnotationLayer={false}
          className={`'two-page-pdf-viewer__page' ${numPages > 1} ? : 'two-page-pdf-viewer__page-two-pages' : 'two-page-pdf-viewer__page-one-page'}`}
        />
      </Document>
    </div>
  );
};

export default TwoPagePdfViewer;
